module.exports = __webpack_public_path__ + "static/img/03040B_1_2_C_20220425_LC.d132dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/03040B_1_2_C_20220425_LC.png
// module id = OI+6
// module chunks = 0